import React, { useEffect, useState } from 'react';

import { User } from 'lucide-react';

import { clsx } from 'clsx';



type UserAvatarSize = 'header' | 'profile';



interface UserAvatarProps {

  avatarUrl?: string | null;

  initials?: string | null;

  size?: UserAvatarSize;

  /** Show green online indicator at top-right of the avatar. */

  showOnlineStatus?: boolean;

  className?: string;

}



const SIZE_CLASSES: Record<

  UserAvatarSize,

  { container: string; text: string; icon: string; fallbackBg: string; imageBg: string; foreground: string }

> = {

  header: {

    container:

      'h-9 w-9 sm:h-12 sm:w-12 backdrop-blur-sm shadow-lg transition-colors hover:bg-white/30',

    text: 'text-[10px] sm:text-xs',

    icon: 'h-5 w-5 sm:h-6 sm:w-6',

    fallbackBg: 'bg-white/20',

    imageBg: 'bg-white/10',

    foreground: 'text-white drop-shadow-lg',

  },

  profile: {

    container: 'h-20 w-20',

    text: 'text-2xl',

    icon: 'h-10 w-10',

    fallbackBg: 'bg-app-primary/15 dark:bg-app-primary/20',

    imageBg: 'bg-app-surface-muted dark:bg-gray-700',

    foreground: 'text-app-primary dark:text-app-primary/90',

  },

};



export const UserAvatar: React.FC<UserAvatarProps> = ({

  avatarUrl,

  initials,

  size = 'header',

  showOnlineStatus = false,

  className,

}) => {

  const [imageFailed, setImageFailed] = useState(false);

  const sizeClasses = SIZE_CLASSES[size];



  useEffect(() => {

    setImageFailed(false);

  }, [avatarUrl]);



  const showImage = Boolean(avatarUrl) && !imageFailed;

  const showInitials = !showImage && Boolean(initials);



  return (

    <span

      className={clsx(

        'relative inline-flex shrink-0 items-center justify-center rounded-full',

        sizeClasses.container,

        showImage ? sizeClasses.imageBg : sizeClasses.fallbackBg,

        className

      )}

      aria-hidden="true"

    >

      {showImage ? (

        <img

          src={avatarUrl!}

          alt=""

          className="absolute inset-0 block h-full w-full rounded-full object-cover object-center"

          onError={() => setImageFailed(true)}

        />

      ) : showInitials ? (

        <span className={clsx('font-bold leading-none', sizeClasses.foreground, sizeClasses.text)}>

          {initials}

        </span>

      ) : (

        <User className={clsx(sizeClasses.foreground, sizeClasses.icon)} />

      )}

      {showOnlineStatus && (

        <span

          className="absolute top-0 right-0 z-10 h-2.5 w-2.5 rounded-full border-2 border-white bg-[#22c55e] shadow-lg"

          aria-hidden="true"

        />

      )}

    </span>

  );

};


